import update from 'immutability-helper'


const initialChoiceBody='\u2063'

export function updateQuestionWithFormValues(value,field,index,question) {
	const nowDate=new Date()
	var updatedQuestion=question
	
	if(field==='removeChoice'){
		updatedQuestion=update(updatedQuestion,
			{choices:  
				{$splice: [[index,1]]
				}})

	}

	if(field==='addChoice'){
		updatedQuestion=update(updatedQuestion,
			{choices:  
				{$push: [{correct:false, body:'new choice'}]
				}})

	}
	if(field==='radio'){

	//if setting a choice to correct set all other choices to incorrect
	//if value is false isCorrect is true
  	let newChoices=[]
		if(value ==='false'){
			updatedQuestion.choices.map(function(choice,i){
				let isCorrect=false
				let choiceBody=choice.body
				if(i===index){
					isCorrect=true
				} 
				if(choiceBody===initialChoiceBody){
					choiceBody=''
				}
				const newChoice={
					body:choiceBody,
					correct:isCorrect,
				}
				newChoices.push(newChoice)
				return null
			})

			updatedQuestion.choices=newChoices
		}

		else if(value ==='true'){
			updatedQuestion.choices[index].correct=false
		}
	}	

	if(field==='image'){


		updatedQuestion= update(updatedQuestion, 
			{image: {$set: value}})

		//if you are deleting the image from a question with template=right set the template to standard
		if (value === '') {
			if (updatedQuestion.template === 'right') {
				updatedQuestion= update(updatedQuestion, 
					{template: {$set: 'standard'}})
			}
			if(question.body===''){
				updatedQuestion= update(updatedQuestion, 
					{body: {$set: 'Click here to edit question'}})  //if deleting an image from a question without a body add default question body to prevent save error
			}
		}
		if (value !== '') {
			if(question.body ==='Click here to edit question'){ //remove default body value if adding an image
				updatedQuestion= update(updatedQuestion, 
					{body: {$set: ''}})
			}			
		}
	}


	updatedQuestion= update(updatedQuestion,{clientModified: {$set: nowDate}})
	return updatedQuestion

}



